import { render, staticRenderFns } from "./QccJudgmentdoccheckDetail.vue?vue&type=template&id=a2575c48&scoped=true&"
import script from "./QccJudgmentdoccheckDetail.vue?vue&type=script&lang=js&"
export * from "./QccJudgmentdoccheckDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2575c48",
  null
  
)

component.options.__file = "QccJudgmentdoccheckDetail.vue"
export default component.exports